import FormView from 'components/FormInstances/FormView'

export default (props) => <FormView {...props} objectType="Job" objectId={props.parentRecord.id} />
